import React from "react";
import BoltOutlinedIcon from "@mui/icons-material/BoltOutlined";
import EmojiEventsOutlinedIcon from "@mui/icons-material/EmojiEventsOutlined";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import SecureConnected from "../components/SecureConnected";
import { SiteFooter, SiteHeader } from "../components/SiteChrome";
import useScrollReveal from "../hooks/useScrollReveal";
import aboutImage from "../assets/figma/About us.png";
import "./About.css";

const values = [
  {
    icon: <BoltOutlinedIcon />,
    title: "Simplicity",
    copy: "Clear, intuitive solutions with less complexity.",
  },
  {
    icon: <FavoriteBorderOutlinedIcon />,
    title: "User First",
    copy: "Built around user needs, trust, and convenience.",
  },
  {
    icon: <EmojiEventsOutlinedIcon />,
    title: "Leading Innovation",
    copy: "Driving change through bold innovation.",
  }
];

export default function About() {
  useScrollReveal();

  return (
    <main className="about-page">
      <SiteHeader />

      <section className="about-hero tl-reveal">
        <h1>About trilLOAN</h1>
        <div className="about-intro">
          <p>
            We are a fintech startup reshaping how lending works. Our
            peer-to-peer platform connects borrowers and lenders directly,
            making borrowing easier.
          </p>
          <img src={aboutImage} alt="trilLOAN app conversation preview" />
        </div>
      </section>

      <section className="vision-section tl-reveal" aria-label="Vision and mission">
        <article>
          <h2>Our Vision</h2>
          <p>To create the simplest loan platform.</p>
        </article>
        <article>
          <h2>Our mission</h2>
          <p>To integrate all the financial institutions in one application.</p>
        </article>
      </section>

      <section className="core-values-section tl-reveal">
        <h2>Core Values</h2>
        <div className="core-values-grid">
          {values.map((value, index) => (
            <article className={`tl-reveal tl-reveal-delay-${index % 3}`} key={value.title}>
              <span>{value.icon}</span>
              <h3>{value.title}</h3>
              <p>{value.copy}</p>
            </article>
          ))}
        </div>
      </section>

      <SecureConnected />
      <SiteFooter />
    </main>
  );
}
